import React from 'react';
import { Trans } from '@lingui/macro';
import { DocSummary } from '../../../models/DTO';


interface IBotAskSummaryPart {
  summaries: DocSummary[],
  onClick: (question: string) => void
}
const BotAskSummaryPart: React.FC<IBotAskSummaryPart> = ({ summaries, onClick }) => {
  return (
    <div className="h-[250px] w-full p-4 overflow-y-auto">
      {summaries.map((s, i) => (
        <div key={`${s.title}-${i}`} className="mb-4 last:mb-0">
          <p className="font-semibold mb-1 text-sm">{i + 1}: {s.title}</p>
          <SummaryText sum={s} />
          {s.question && getQuestions(s.question).map((question, qIdx) =>
            question.length > 2 && (
              <p key={`${question}-${qIdx}`} className="ml-2 mt-1 text-sm">
                <a
                  onClick={() => onClick(`${question}`)}
                  className="text-blue-600 hover:text-blue-800 cursor-pointer hover:underline"
                >
                  {question}
                </a>
              </p>
            )
          )}
        </div>
      ))}
    </div>
  );

  function getQuestions(questionString: string): string[] {
    // convert ["question1?","question2?"] to array of questions
    questionString = questionString.replaceAll('\n', '')
    const list = questionString.trim().split('?').map(q => `${q.replaceAll(/\d+\.\s/g, '')}?`)
    return list;
  }
}

const SummaryText: React.FC<{ sum: DocSummary }> = ({ sum }) => {
  const shortLength = 80;
  const [showAll, setShowAll] = React.useState(sum.summary.length < shortLength);

  return (
    <div
      className="text-sm text-[color:rgb(var(--text-body))] cursor-pointer bg-muted/50 p-2 rounded hover:bg-muted transition-colors"
      onClick={() => setShowAll(p => !p)}
    >
      {showAll ? sum.summary : (
        <>
          {sum.summary.substring(0, shortLength)}...
          <span className="text-muted-foreground text-xs ml-1"><Trans>click for more</Trans></span>
        </>
      )}
      {showAll && (
        <div className="text-xs text-muted-foreground mt-1">
          <Trans>Page:</Trans> {sum.pages}, {sum.filename}.
        </div>
      )}
    </div>
  )
}

export default BotAskSummaryPart;